import styles from '@/app/ui/components/navigation/nav-item.module.css';

import { Button } from '@radix-ui/themes';
import React from 'react';
import Link from 'next/link';
import { ColorType } from '@/app/lib/schemas/types/shared';

interface MyButtonProps {
  children: React.ReactNode; // Используем children вместо label
  color: ColorType;
  onClick: () => void;
}

const NavButton = React.forwardRef<HTMLButtonElement, MyButtonProps>(
  ({ children, color, onClick, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        variant='ghost'
        color={color}
        asChild
        onClick={onClick}
        {...props}
      >
        <div style={{ textAlign: 'left' }}>{children}</div>
      </Button>
    );
  }
);

NavButton.displayName = 'NavButton'; // Нужно для отладки в DevTools

interface Props {
  href: string;
  isActive: boolean;
  label: string;
  onClick: () => void;
}

export default function SidebarNavItem({
  href,
  label,
  onClick,
  isActive
}: Props) {
  return (
    <Link
      href={href}
      passHref
      className={styles.Anchor}
    >
      <NavButton
        color={isActive ? 'jade' : 'gray'}
        onClick={onClick}
      >
        {label}
      </NavButton>
    </Link>
  );
}
